<template>
    <div>
        <div class="container-subs">
            <div class="block-facturation block-subs-left">
                <h1 @click="addressShow = !addressShow">
                    Adresse de facturation <i class="fas fa-sort-down"></i>
                </h1>
                <div v-show="addressShow">
                    <h2>
                        {{ address.company }}
                    </h2>
                    <p>
                        {{ address.address }} {{ address.zip }} {{ address.city }}
                    </p>
                    <p>{{ address.tel }}</p>
                </div>
            </div>
            <div v-if="inGroup && hasContract" class="block-accord block-subs-left">
                <h1 @click="accordGroupShow = !accordGroupShow">
                    Accord de groupe <i class="fas fa-sort-down"></i>
                </h1>
                <div v-show="accordGroupShow">
                    <h2>
                        Étant membre du réseau "{{ group.name }}", vous bénéficiez d'un
                      pourcentage de retrocession négocié à {{successFeesRate}}%
                    </h2>
                    <h2 class="doc">
                        Vous pouvez télécharger le(s) document(s) ci-dessous.
                        <div>
                            <i class="fas fa-download"></i> <a :href="contratGroupeURL"><span>Accord de groupe</span></a>
                        </div>
                    </h2>
                    <h2>
                      Veuillez renseigner le code postal de chalandise attaché à cet abonnement.
                    </h2>

                    <br>
                    <div class="postal-code">
                      <input class="control control--input"  v-model="postalCode" placeholder="Code Postal">
                      <button  class="postal-code" @click="checkPostalCode()">Vérifier la disponibilité</button>
                    </div>
                    <br>
                    <br>
                    <label class="control control--small control--chechbox label-cgu"
                        title="Cocher la case pour accepter les CGV">
                        <input type="checkbox" name="cgu" v-model="cguChecked"> J'ai lu et j'accepte les
                        <a href="/assets/CGU_pros.pdf" target="cgu_premium">conditions générales d'utilisation</a>
                    </label>
                </div>
            </div>
            <div v-else class="block-accord block-subs-left">
                <h1>
                    Code Postal
                </h1>
                <div>
                    <h2>
                        Veuillez renseigner le code postal de chalandise attaché à cet abonnement.
                    </h2>

                    <br>
                    <div class="postal-code">
                      <input class="control control--input"  v-model="postalCode" placeholder="Code Postal">
                      <button  class="postal-code" @click="checkPostalCode()">Vérifier la disponibilité</button>
                    </div>
                    <br>
                    <br>
                    <label class="control control--small control--chechbox label-cgu"
                        title="Cocher la case pour accepter les CGV">
                        <input id="cgu" type="checkbox" name="cgu" v-model="cguChecked"> J'ai lu et j'accepte les
                        <a href="/assets/CGU_pros.pdf" target="cgu_premium">conditions générales d'utilisation</a>
                    </label>
                </div>
            </div>
            <div class="block-pricing block-subs-left">
                <h1 @click="paymentShow = !paymentShow">
                    Mode de paiement <i class="fas fa-sort-down"></i>
                </h1>
                <div v-show="paymentShow">
                    <span v-show="cannotSubscribe">
                        Vous ne pouvez pas souscrire à cette offre directement, merci de prendre contact avec nos services
                        pour poursuivre.
                    </span>
                    <div v-show="!cannotSubscribe" id="appStripe">
                        <stripe-payment ref="stripePayment" :professional="professional" :address="address" :plan-stripe-id="plan['stripe_id']"
                            :plan-name="plan['name']" @change-numbers="changeNumbers" @load-payment-on="loadPayment = true"
                            @load-payment-off="loadPayment = false"></stripe-payment>
                    </div>
                </div>
            </div>
            <div class="block-infos block-subs-right">
                <h1 class="premium"> Votre formule</h1>
                <h2>{{ plan['name'] }}</h2>
                <h3>Accès prioritaire</h3>
                <div v-for="option in pricingOptions.details" :key="option">
                    <img src="/assets/img/check.svg" alt=""> <span>{{ option }}</span>
                </div>
                <br>
                <div class="pricing">
                    <span class="price">{{ pricingOptions.price }}</span>
                </div>
            </div>
        </div>
        <button id="validate-stripe-payment" class="validate" :class="{ 'button--is-loading': loadPayment }" :disabled="cannotPay"
            @click="validatePayment()">Valider ma formule</button>
    </div>
</template>

<script>
import StripePayment from './StripePayment';
import Pricing from '../../../shared/mixins/Pricing';
import axios from "axios";

const TYPE_PAYMENT_IBAN = 'iban';

export default {
    name: 'checkout',
    components: {
        StripePayment
    },
    mixins: [Pricing],
    props: {
        professional: Object,
        plan: Object,
        cannotSubscribe: Boolean,
        group: [Array, Object],
        contract: [Array, Object],
        address: [Object]
    },
    data() {
        return {
            canPayByCard: false,
            cguChecked: false,
            loadPayment: false,
            typePayment: TYPE_PAYMENT_IBAN,
            accordGroupShow: true,
            addressShow: true,
            paymentShow: true,
            postalCode: '',
        };
    },
    computed: {

        inGroup() {
            return this.group.length !== 0;
        },
        hasContract() {
            return this.contract.length !== 0;
        },
        successFeesRate() {
            if (this.hasContract) {
                switch (this.plan['id']) {
                    case 'new-premium':
                        return this.contract.success_fees_rate;
                    case 'new-premium-plus':
                        return this.contract.success_fees_rate;
                    case 'rdv-mandat':
                        return this.contract.success_fees_manual_rate;
                }
            }
            return this.hasContract ? this.contract.success_fees_rate : this.plan.default_rate;
        },
        contratGroupeURL() {
            return '/api/professional/group/' + this.group.id + '/documents/contract/current/download';
        },
        cannotPay() {
            return this.plan['payment'] && !this.canPayByCard || this.cannotSubscribe;
        },
        pricingOptions() {
          return this.options.first;
        },
    },
    methods: {
        changeNumbers(completed, type) {
            this.canPayByCard = completed;
        },
        validatePayment() {
            if (!this.cguChecked) {
                this.$swal({
                    text: `Veuillez accepter les conditions générales d'utilisation`,
                    type: `warning`,
                })
                return;
            }
            if(this.postalCode === '') {
                this.$swal({
                    text: `Veuillez renseigner le code postal`,
                    type: `warning`,
                })
                return;
            }
            document.getElementById('validate-stripe-payment').disabled = true;
            this.$refs.stripePayment.payByIban(this.postalCode);
        },
        checkPostalCode() {

          console.log(/[0-9]{5}/.test(this.postalCode));
            if(this.postalCode === '' || !(/^[0-9]{5}$/.test(this.postalCode))) {
                this.$swal({
                    text: `Veuillez renseigner un code postal correct`,
                    type: `warning`,
                })
                return;
            }
            axios.get(`/api/stripe/check-postal-code?postalCode=${this.postalCode}`)
                .then(response => {
                    if(response.data.success) {
                        this.$swal({
                            text: `Le code postal est disponible`,
                            type: `success`,
                        })
                    } else {
                        this.$swal({
                            text: response.data.message,
                            type: `warning`,
                        })
                    }
                })
                .catch(error => {
                    this.$swal({
                        text: `Une erreur est survenue`,
                        type: `error`,
                    })
                });
        }
    },
}
</script>
<style >
.validate {
    border: none;
}

.validate:disabled {
    opacity: 0.5;
}

.postal-code {
  display: flex;
  justify-content: center;
  align-items: center;
}

.postal-code button {
  border: none;
  padding: 8px;
  margin-left: 10px;
  background-color: #cd7d5d;
  border-radius: 40px;
  color: white;
  font-size: .6rem;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 1s;
}

.postal-code button:hover {
  background-color: #ecc358;
}

#cgu {
    max-width: 30px;
}

.doc>div {
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// application/assets/js/professional/containers/Subscriptions/Checkout.vue